import { render } from "./IconCameraFilled.vue?vue&type=template&id=db0867d4"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconCameraFilled.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "db0867d4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('db0867d4', __exports__)) {
    api.reload('db0867d4', __exports__)
  }
  
  module.hot.accept("./IconCameraFilled.vue?vue&type=template&id=db0867d4", () => {
    api.rerender('db0867d4', render)
  })

}


export default __exports__